export const snackBarMessageSelector = (state: any) => state.snackBar.message;